module.exports = __webpack_public_path__ + "img/lock_text_w.f9165845.svg";